import { Link } from "react-router-dom";
import Logo from "../assets/mb_mailer.png";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex flex-col items-center justify-center text-white px-4">
      <img src={Logo} alt="MBMailer Logo" className="w-28 mb-6" />
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-xl mb-6">Oops! Page not found.</p>
      <Link
        to="/"
        className="bg-white text-blue-600 font-semibold px-6 py-2 rounded shadow hover:bg-gray-100 transition"
      >
        Go Back Home
      </Link>
    </div>
  );
}
